import { defineComponent, mergeModels, ref, useModel, computed, onMounted, openBlock, createElementBlock, withDirectives, createElementVNode, createTextVNode, toDisplayString, createCommentVNode, createVNode, unref, withCtx, vShow, withModifiers } from "vue";
import { CdrLink, CdrFormGroup, IconExternalLink, CdrPopover, IconInformationFill, CdrCheckbox } from "@rei/cedar";
const _hoisted_1 = {
  class: "membership"
};
const _hoisted_2 = {
  class: "membership__dividend-text"
};
const _hoisted_3 = {
  class: "membership__dividend-text--amount",
  "data-ui": "product-dividend-savings"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  class: "membership__membership-wrapper"
};
const _hoisted_6 = {
  class: "membership__dividend-text",
  "data-ui": "member-rewards"
};
const _hoisted_7 = {
  class: "membership__dividend-text",
  "data-ui": "member-rewards"
};
const _hoisted_8 = {
  class: "membership__dividend-text--amount",
  "data-ui": "product-membership-savings"
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  class: "membership__add-membership-text",
  "data-ui": "member-only-unvalidated"
};
const _hoisted_11 = {
  class: "membership__add-membership-text",
  "data-ui": "member-only-validated"
};
const _hoisted_12 = {
  class: "membership__logged-in-nonmember-actiontext"
};
const _hoisted_13 = {
  class: "membership__info-text-icon-wrapper"
};
const _hoisted_14 = {
  class: "membership__popover-text"
};
const _hoisted_15 = {
  class: "membership__dividend-text"
};
const _hoisted_16 = {
  id: "membership-error-text",
  class: "membership__membership-error-text"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxMembership",
  props: /* @__PURE__ */ mergeModels({
    accountMembershipLink: {},
    amount: {},
    error: {
      type: Boolean
    },
    includeMembership: {
      type: Boolean
    },
    isLoggedIn: {
      type: Boolean
    },
    loginPath: {},
    dividendPercentage: {
      default: ""
    },
    showMemberOnlyCheckbox: {
      type: Boolean
    },
    showDividendMessage: {
      type: Boolean
    },
    showAnyCheckbox: {
      type: Boolean
    },
    showRewardsMessageCheckbox: {
      type: Boolean
    },
    showMembershipMessageCheckbox: {
      type: Boolean,
      default: false
    },
    showMABCOffPrice: {
      type: Boolean,
      default: false
    },
    membershipCost: {}
  }, {
    "modelValue": {
      type: Boolean,
      ...{}
    },
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["dividendClick", "includeMembership", "memberInfoClick", "metricsClick", "registerRef"], ["update:modelValue"]),
  setup(__props, {
    emit: __emit
  }) {
    const membership = ref(null);
    const props = __props;
    const emit = __emit;
    const addMembership = useModel(__props, "modelValue", {
      get: () => props.includeMembership,
      set: (value) => emit("includeMembership", value)
    });
    const loginLink = computed(() => props.loginPath.split("?")[0]);
    const dividendPercentageText = computed(() => props.dividendPercentage ? ` (${props.dividendPercentage}) ` : "");
    onMounted(() => {
      var _a;
      if (membership.value) {
        emit("registerRef", {
          type: "membership",
          value: (_a = membership == null ? void 0 : membership.value) == null ? void 0 : _a.$el
        });
      }
    });
    function handleAddMembershipCheckbox() {
      if (props.includeMembership) {
        emit("metricsClick", {
          linkName: "add membership checked"
        });
      }
    }
    function handleLoginClick(event, win = window) {
      event.preventDefault();
      win.location.href = props.loginPath;
    }
    function handleInfoBtnClick() {
      emit("metricsClick", {
        linkName: "membership info"
      });
    }
    function handleAccountPageClick() {
      emit("metricsClick", {
        linkName: "membership info_account page"
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [withDirectives(createElementVNode("div", null, [createElementVNode("p", _hoisted_2, [_cache[5] || (_cache[5] = createTextVNode(" Members get an estimated ")), createElementVNode("span", _hoisted_3, toDisplayString(_ctx.amount), 1), dividendPercentageText.value ? (openBlock(), createElementBlock("span", _hoisted_4, toDisplayString(dividendPercentageText.value), 1)) : createCommentVNode("", true), _cache[6] || (_cache[6] = createTextVNode(" back on this item as a part of your annual ")), createVNode(unref(CdrLink), {
        tag: "button",
        type: "button",
        "data-ui": "product-show-dividend-message",
        "aria-haspopup": "dialog",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("dividendClick"))
      }, {
        default: withCtx(() => _cache[4] || (_cache[4] = [createTextVNode(" Co-op Member Reward ")])),
        _: 1,
        __: [4]
      }), _cache[7] || (_cache[7] = createTextVNode(". "))])], 512), [[vShow, _ctx.showDividendMessage && !_ctx.showAnyCheckbox]]), withDirectives(createElementVNode("div", _hoisted_5, [createVNode(unref(CdrFormGroup), {
        ref_key: "membership",
        ref: membership,
        "data-ui": "membership-fieldset",
        error: _ctx.error,
        tabindex: _ctx.error ? -1 : null,
        "aria-describedby": _ctx.error ? "membership-error-text" : null
      }, {
        label: withCtx(() => [withDirectives(createElementVNode("div", _hoisted_6, [createElementVNode("div", null, [_cache[9] || (_cache[9] = createTextVNode(" Treat yourself to new gear & clothing! Join the co-op to get a ")), _cache[10] || (_cache[10] = createElementVNode("span", {
          class: "membership__dividend-text--amount"
        }, "$30 bonus card", -1)), _cache[11] || (_cache[11] = createTextVNode(" when you spend $50. ")), createVNode(unref(CdrLink), {
          class: "membership__external-link",
          href: "/member-thanks",
          target: "_blank"
        }, {
          default: withCtx(() => [_cache[8] || (_cache[8] = createTextVNode(" Details ")), createVNode(unref(IconExternalLink))]),
          _: 1,
          __: [8]
        })])], 512), [[vShow, _ctx.showMABCOffPrice]]), withDirectives(createElementVNode("div", _hoisted_7, [_cache[12] || (_cache[12] = createTextVNode(" Members get an estimated ")), createElementVNode("span", _hoisted_8, toDisplayString(_ctx.amount), 1), dividendPercentageText.value ? (openBlock(), createElementBlock("span", _hoisted_9, toDisplayString(dividendPercentageText.value), 1)) : createCommentVNode("", true), _cache[13] || (_cache[13] = createTextVNode(" back on this item. "))], 512), [[vShow, _ctx.showRewardsMessageCheckbox]]), withDirectives(createElementVNode("div", null, [withDirectives(createElementVNode("div", _hoisted_10, [_cache[15] || (_cache[15] = createElementVNode("strong", null, "To buy,", -1)), _cache[16] || (_cache[16] = createTextVNode("  ")), createVNode(unref(CdrLink), {
          href: loginLink.value,
          onClick: handleLoginClick
        }, {
          default: withCtx(() => _cache[14] || (_cache[14] = [createTextVNode(" sign in ")])),
          _: 1,
          __: [14]
        }, 8, ["href"]), _cache[17] || (_cache[17] = createTextVNode(" as an REI Co-op Member or join now. "))], 512), [[vShow, !_ctx.isLoggedIn]]), withDirectives(createElementVNode("div", _hoisted_11, [createVNode(unref(CdrPopover), {
          id: "membership-more-info",
          class: "membership__info-wrapper"
        }, {
          trigger: withCtx(() => [createElementVNode("button", {
            ref: "membershipText",
            type: "button",
            class: "membership__info-button",
            onClick: handleInfoBtnClick
          }, [createElementVNode("span", _hoisted_12, [_cache[19] || (_cache[19] = createElementVNode("span", {
            class: "membership__logged-in-nonmember-actiontext--emphasis"
          }, " To buy this item, ", -1)), _cache[20] || (_cache[20] = createTextVNode(" become an REI Co-op ")), createElementVNode("span", _hoisted_13, [_cache[18] || (_cache[18] = createTextVNode(" Member. ")), createVNode(unref(IconInformationFill), {
            class: "membership__info-icon",
            "inherit-color": ""
          })]), _cache[21] || (_cache[21] = createElementVNode("span", {
            class: "pdp-sr-only"
          }, " Get more info about buying this just for members item. ", -1))])], 512)]),
          default: withCtx(() => [createElementVNode("div", _hoisted_14, [_cache[23] || (_cache[23] = createTextVNode(" You’re signed in to your REI online account, but a membership is not attached to that account. ")), createVNode(unref(CdrLink), {
            ref: "accountPageLink",
            href: _ctx.accountMembershipLink,
            onClick: handleAccountPageClick
          }, {
            default: withCtx(() => _cache[22] || (_cache[22] = [createTextVNode(" Link your member number, ")])),
            _: 1,
            __: [22]
          }, 8, ["href"]), _cache[24] || (_cache[24] = createTextVNode(" or purchase a membership. "))])]),
          _: 1
        })], 512), [[vShow, _ctx.isLoggedIn]])], 512), [[vShow, _ctx.showMemberOnlyCheckbox]]), withDirectives(createElementVNode("div", _hoisted_15, [_cache[26] || (_cache[26] = createTextVNode(" Join the co-op today to get access to ")), createVNode(unref(CdrLink), {
          tag: "a",
          class: "membership-message-button",
          "data-ui": "product-show-membership-newmessage",
          "aria-haspopup": "dialog",
          onClick: _cache[1] || (_cache[1] = withModifiers(($event) => _ctx.$emit("memberInfoClick"), ["prevent"]))
        }, {
          default: withCtx(() => _cache[25] || (_cache[25] = [createTextVNode(" a lifetime of benefits. ")])),
          _: 1,
          __: [25]
        })], 512), [[vShow, _ctx.showMembershipMessageCheckbox]])]),
        error: withCtx(() => [createElementVNode("span", _hoisted_16, [_cache[31] || (_cache[31] = createTextVNode(" Please ")), withDirectives(createElementVNode("span", null, "sign in or", 512), [[vShow, !_ctx.isLoggedIn]]), _cache[32] || (_cache[32] = createTextVNode(" add a membership to cart "))])]),
        default: withCtx(() => [createVNode(unref(CdrCheckbox), {
          modelValue: addMembership.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => addMembership.value = $event),
          size: "small",
          "label-class": "membership__checkbox-wrapper",
          "content-class": "membership__checkbox-text",
          "data-ui": "product-information-add-membership",
          onChange: handleAddMembershipCheckbox
        }, {
          default: withCtx(() => [_cache[28] || (_cache[28] = createTextVNode(" Add a ")), createVNode(unref(CdrLink), {
            tag: "button",
            type: "button",
            "data-ui": "product-show-membership-message",
            "aria-haspopup": "dialog",
            onClick: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("memberInfoClick"))
          }, {
            default: withCtx(() => _cache[27] || (_cache[27] = [createTextVNode(" lifetime membership ")])),
            _: 1,
            __: [27]
          }), _cache[29] || (_cache[29] = createTextVNode(" for a ")), _cache[30] || (_cache[30] = createElementVNode("strong", null, "one-time fee", -1)), createTextVNode(" of $" + toDisplayString(_ctx.membershipCost), 1)]),
          _: 1,
          __: [28, 29, 30]
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["error", "tabindex", "aria-describedby"])], 512), [[vShow, _ctx.showAnyCheckbox]])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxMembership2.mjs.map
